import { useGlobalErrorHandler } from '@luminovo/data-stack';
import { useQueryClient } from '@tanstack/react-query';

import { setQueryErrorListener } from './appQueryClient';

/** Routes the query cache's errors to the global handler; render inside the snackbar provider it reports through. */
export function GlobalQueryErrorHandler(): null {
    const client = useQueryClient();
    const { onError } = useGlobalErrorHandler(client);

    // During render, not in an effect, so the listener is in place before queries start, even if the commit suspends.
    setQueryErrorListener(client, (error, query) => {
        const silent = query.meta?.globalErrorHandler === false;
        onError({ error, silent, silentUnknownError: true });
    });

    return null;
}
